import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { axiosInstance } from "..";
import toast from "react-hot-toast";
import messages from "../../assets/Local/Local";
import axios from "axios";

const initialState = {
  allDeals: [],
  pipelines: [],
  organizationsLookups: [],
  stagesLookups: [],
  ownersLookups: [],
  personsLookups: [],
  filters: [],
  dealDetails: null,
  dealNotes: null,
  dealActivities: null,
  activityTypes: [],
  priorities: [],
  lostReasons: [],
  dealLogs: null,
};


export const getDeals = createAsyncThunk(
  "deals/getDeals",
  async (filteredData) => {
    const response = await axiosInstance.get("Pipedrive/deals", { params: filteredData });

    return response.data;
  }
);

export const getDealDetails = createAsyncThunk(
  "deals/getDealDetails",
  async (dealId) => {
    const response = await axiosInstance.get(`Pipedrive/deals/${dealId}`);
    return response.data;
  }
);

export const getFilters = createAsyncThunk("filters", async () => {
  const response = await axiosInstance.get("Pipedrive/filters?type=deals", {

  });

  return response.data;
});

export const getFilteredDeals = createAsyncThunk(
  "deals/getFilteredDeals",
  async (searchData) => {
    const response = await axiosInstance.get("Pipedrive/deals/search", {
      params: searchData,
    });

    return response.data;
  }
);

export const getPipelines = createAsyncThunk('Pipedrive/getPipelines',
  async () => {
    const response = await axiosInstance.get("Pipedrive/pipelines");
    return response.data;

  })
export const getPersons = createAsyncThunk('Pipedrive/getPersons',
  async () => {
    const response = await axiosInstance.get("Pipedrive/persons",);
    return response.data;

  })
export const getOwners = createAsyncThunk('Pipedrive/getOwners',
  async () => {
    const response = await axiosInstance.get("Pipedrive/owners");
    return response.data;

  })
export const getOrganizations = createAsyncThunk('Pipedrive/getOrganizations',
  async () => {
    const response = await axiosInstance.get("Pipedrive/organizations");
    return response.data;

  })
export const getStages = createAsyncThunk('Pipedrive/getStages',
  async (pipeline_id) => {
    const response = await axiosInstance.get("Pipedrive/stages", {
      params: {
        pipeline_id,
      }
    });
    return response.data;

  })



export const addOrganizations = createAsyncThunk('Pipedrive/addOrganization',
  async (data, { dispatch }) => {
    const response = await axiosInstance.post("Pipedrive/organization", data);
    dispatch(getOrganizations())
    return response.data;

  })

export const addOPersons = createAsyncThunk('Pipedrive/addOPersons',
  async (data, { dispatch }) => {
    const response = await axiosInstance.post("Pipedrive/persons", data);
    dispatch(getPersons())
    return response.data;

  })

export const addDeal = createAsyncThunk('Pipedrive/addDeal',
  async (data, { dispatch }) => {
    const response = await axiosInstance.post("Pipedrive/deals", data);
    dispatch(getDeals({ sort: "add_time DESC" }))
    toast.success(messages[localStorage.getItem("lang")].shared.done);

    return response.data;

  })
export const getDealNotes = createAsyncThunk('Pipedrive/getDealNotes',
  async (dealId, { dispatch }) => {
    const response = await axiosInstance.get("Pipedrive/deals/" + dealId + "/notes");
    // dispatch(getDealDetails(data.id))
    return response.data;

  })
export const addNote = createAsyncThunk('Pipedrive/addNote',
  async (data, { dispatch }) => {
    const response = await axiosInstance.post("Pipedrive/notes", data);
    dispatch(getDealNotes(data.deal_id))
    toast.success(messages[localStorage.getItem("lang")].shared.done);

    return response.data;

  })

export const updateDeal = createAsyncThunk('Pipedrive/updateDeal',
  async (data, { dispatch }) => {
    const response = await axiosInstance.put("Pipedrive/deals/" + data.id, data);
    dispatch(getDealDetails(data.id))
    toast.success(messages[localStorage.getItem("lang")].shared.done);

    return response.data;

  })

export const addDealActivity = createAsyncThunk('Pipedrive/addDealActivity',
  async (data, { dispatch }) => {
    const response = await axiosInstance.post("Pipedrive/activities", data);
    dispatch(getAllDealActivities(data.deal_id))
    toast.success(messages[localStorage.getItem("lang")].shared.done);

    return response.data;

  })

export const getAllDealActivities = createAsyncThunk('Pipedrive/getAllDealActivities',
  async (dealId, { dispatch }) => {
    const response = await axiosInstance.get(`Pipedrive/deals/${dealId}/activities`);
    // dispatch(getDealDetails(data.id))
    return response.data;

  })
export const updateDealActivity = createAsyncThunk('Pipedrive/updateDealActivity',
  async (data, { dispatch }) => {
    const response = await axiosInstance.put("Pipedrive/activities/" + data.id, data);
    dispatch(getAllDealActivities(data.deal_id))
    toast.success(messages[localStorage.getItem("lang")].shared.done);

    return response.data;
  })


export const getActivityTypes = createAsyncThunk('Pipedrive/getActivityTypes',
  async () => {
    const response = await axiosInstance.get("Pipedrive/activity-types", {
    });
    return response.data;
  })

export const getDealPriority = createAsyncThunk('Pipedrive/getDealPriority',
  async () => {
    const response = await axiosInstance.get("Pipedrive/Priority", {
    });
    return response.data;
  })




export const getLostReasons = createAsyncThunk('Pipedrive/getLostReasons',
  async () => {
    const response = await axiosInstance.get("Pipedrive/lost-reasons", {
    });
    return response.data;
  })

export const uploadPipedriveDocument = createAsyncThunk(
  "Pipedrive/uploadPipedriveDocument",
  async (data, { dispatch }) => {
    return await axios({
      method: "post",
      url: `${process.env.REACT_APP_BASE_URL}Pipedrive/deals/${data.dealId}/files`,
      data: data.bodyFormData,
      headers: {
        "Content-Type": "multipart/form-data",
        'Authorization': `Bearer ${localStorage.getItem("token")}`
      },
    })
      .then(function (response) {
        toast.success(messages[localStorage.getItem("lang")].shared.done);
        dispatch(getDealDetails(data.dealId))
        return response
      })
      .catch(function (error) {
        toast.error(error.response.data.error.message);
      });

  }
);

export const getDealLogs = createAsyncThunk('Pipedrive/getDealLogs',
  async (dealId) => {
    const response = await axiosInstance.get(`Pipedrive/deals/${dealId}/changelog`, {
    });
    return response.data;
  })

const DealsSlice = createSlice({
  name: "Pipedrive",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(getDeals.fulfilled, (state, action) => {
      state.allDeals = action.payload.data ? action.payload.data : [];
    });
    builder.addCase(getFilteredDeals.fulfilled, (state, action) => {
      state.allDeals = action.payload.data.items;
    });
    builder.addCase(getFilters.fulfilled, (state, action) => {
      state.filters = action.payload.data.map((ele) => {
        return { id: ele.id, name_en: ele.name, name_ar: ele.name };
      });
    });
    builder.addCase(getPipelines.fulfilled, (state, action) => {
      state.pipelines = action.payload.data.map((ele) => {
        return { id: ele.id, name_en: ele.name, name_ar: ele.name };
      });

    })
    builder.addCase(getOwners.fulfilled, (state, action) => {
      state.ownersLookups = action.payload.data.map((ele) => {
        return { id: ele.id, name_en: ele.name, name_ar: ele.name };
      });

    })
    builder.addCase(getOrganizations.fulfilled, (state, action) => {
      state.organizationsLookups = action.payload.data.map((ele) => {

        return { id: ele.id, name_en: ele.name, name_ar: ele.name };
      });

    })
    builder.addCase(getPersons.fulfilled, (state, action) => {
      state.personsLookups = action.payload.data.map((ele) => {
        return { id: ele.id, name_en: ele.name, name_ar: ele.name };
      });

    })
    builder.addCase(getStages.fulfilled, (state, action) => {
      state.stagesLookups = action.payload.data.map((ele) => {
        return { id: ele.id, name_en: ele.name, name_ar: ele.name };
      });
    })
    builder.addCase(getDealDetails.fulfilled, (state, action) => {
      state.dealDetails = action.payload.data[0]
    })
    builder.addCase(getDealNotes.fulfilled, (state, action) => {
      state.dealNotes = action.payload.data;
    })
    builder.addCase(getAllDealActivities.fulfilled, (state, action) => {
      state.dealActivities = action.payload.data;
    })
    builder.addCase(getActivityTypes.fulfilled, (state, action) => {
      state.activityTypes = action.payload.data;
    })
    builder.addCase(getDealPriority.fulfilled, (state, action) => {
      state.priorities = action.payload.data.map(ele => ({
        name_en: ele.label,
        name_ar: ele.label,
        id: ele.id
      }))
      // state.priorities = action.payload.data;
    })

    builder.addCase(getLostReasons.fulfilled, (state, action) => {
      state.lostReasons = action.payload.data.map(ele => ({
        name_en: ele.label,
        name_ar: ele.label,
        id: ele.id

      }))
    })
    builder.addCase(getDealLogs.fulfilled, (state, action) => {
      state.dealLogs = action.payload.data;
    })
  },
});
export const DealsReducer = DealsSlice.reducer;
